import React from 'react'
import { SvgProps } from 'src/shared/types/svg-props-type'

export const MarginLeftIcon = (props?: SvgProps) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <title>{props?.title}</title>
    <path
      d="M5.83398 6.5L5.83398 13.5C5.83398 14.9001 5.83398 15.6002 6.03078 16.135C6.20388 16.6054 6.4801 16.9878 6.81983 17.2275C7.20606 17.5 7.71167 17.5 8.72287 17.5L13.7784 17.5C14.7896 17.5 15.2952 17.5 15.6815 17.2275C16.0212 16.9878 16.2974 16.6054 16.4705 16.135C16.6673 15.6002 16.6673 14.9001 16.6673 13.5L16.6673 10L16.6673 6.5C16.6673 5.09987 16.6673 4.3998 16.4705 3.86502C16.2974 3.39462 16.0212 3.01217 15.6815 2.77248C15.2952 2.5 14.7896 2.5 13.7784 2.5L8.72287 2.5C7.71167 2.5 7.20606 2.5 6.81983 2.77248C6.4801 3.01217 6.20388 3.39462 6.03078 3.86502C5.83398 4.3998 5.83398 5.09987 5.83398 6.5Z"
      stroke="var(--color-iconTertiary)"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2.5 5.41537L2.5 9.9987L2.5 14.582"
      stroke="var(--color-iconTertiary)"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
